import { render, staticRenderFns } from "./draw3DLineCanvas2item.vue?vue&type=template&id=10af6804&scoped=true"
import script from "./draw3DLineCanvas2item.vue?vue&type=script&lang=js"
export * from "./draw3DLineCanvas2item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af6804",
  null
  
)

export default component.exports